import React, { ReactElement, useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';

import { classNames } from 'utils/css';
import { getHtmlElement } from './Modal.utils';

import { TModalProps } from './Modal.types';
import { BaseContent } from './components/BaseContent';
import styles from './Modal.module.scss';

function Modal({
  visible,
  shouldCloseOnOverlayClick = true,
  onClose,
  onPrimaryClick,
  base: Component = BaseContent,
  primaryActionText = 'Tamam',
  secondaryAction,
  className,
  children,
}: TModalProps): ReactElement {
  const portalContainer = useRef(document.createElement('div'));

  useEffect(() => {
    const htmlElement = getHtmlElement('modal-portal');
    htmlElement.appendChild(portalContainer.current);

    return () => {
      htmlElement.removeChild(portalContainer.current);
    };
  }, []);

  function handleOnClose() {
    onClose && onClose();
  }
  function handleOnPrimaryClick(
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) {
    onPrimaryClick && onPrimaryClick(event);
  }

  function handleOverlayClick() {
    shouldCloseOnOverlayClick && handleOnClose();
  }

  function renderModalMarkup() {
    return (
      visible && (
        <div role="presentation" data-testid="Modal">
          <div className={classNames(styles.wrapper, className)}>
            <Component
              onClose={handleOnClose}
              onPrimaryClick={handleOnPrimaryClick}
              primaryActionText={primaryActionText}
              secondaryAction={secondaryAction}>
              {children}
            </Component>
          </div>
          <div
            aria-hidden="true"
            data-testid="ModalOverlay"
            className={styles.overlay}
            onClick={handleOverlayClick}
          />
        </div>
      )
    );
  }

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return createPortal(renderModalMarkup(), portalContainer.current);
}

export default Modal;
